import * as React from 'react'
import styled from 'styled-components'
import ToggleButton from 'LuxKit/ToggleButton'
import config from 'constants/config'
import { LUXURY_ESCAPES } from 'constants/brands'
import { getNavigationMenuIcon } from 'content/components/Icon/utils'
import LEGiftCardIcon from './LEGiftCardIcon'

const FullWidthToggle = styled(ToggleButton)`
  width: 100%;

  /* As per design, the primary toggle button should have a border color. */
  &&.kind-primary {
    border-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }
`

interface Props {
  navItem: App.NavItem
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

function NavBarHamburgerMenuToggleItem(props: Props) {
  const { navItem, onClick } = props
  const iconName = navItem.sideNavIconName || navItem.iconName
  const DefaultIcon = iconName ? getNavigationMenuIcon(iconName) : undefined
  const startIcon = config.BRAND === LUXURY_ESCAPES && navItem.id === 'nav-link-gift-cards'
    ? <LEGiftCardIcon />
    : DefaultIcon ? <DefaultIcon /> : undefined

  return (
    <FullWidthToggle
      kind="primary"
      orientation="vertical"
      title={navItem.text}
      startIcon={startIcon}
      to={navItem.to}
      href={navItem.href}
      onClick={onClick}
    />
  )
}

export default NavBarHamburgerMenuToggleItem
